interface IProcessorStatusesIconProps {
  className?: string;
}

/**
 * Three stacked horizontal queue rails with a dot on each — a nod to the
 * "rows in a queue, status per row" framing of the tool. The middle row's dot
 * is filled to suggest "currently running"; the others are open. Monoline,
 * `currentColor`, no fills (except the one accent dot which uses currentColor
 * to remain themable). Sized on a 48×48 grid.
 */
const ProcessorStatusesIcon = ({ className }: IProcessorStatusesIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* outer frame */}
    <rect x="6" y="9" width="36" height="30" rx="2" />
    {/* three rails */}
    <path d="M12 18 h24" />
    <path d="M12 24 h24" />
    <path d="M12 30 h24" />
    {/* status dots: open / filled / open — middle row "running" */}
    <circle cx="14" cy="18" r="1.6" />
    <circle cx="14" cy="24" r="1.6" fill="currentColor" />
    <circle cx="14" cy="30" r="1.6" />
  </svg>
);

export default ProcessorStatusesIcon;
